import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconUnfold = createIcon({
  displayName: 'IconUnfold',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M12 4.41L17.29 9.71L18.71 8.29L12 1.59L5.29001 8.29L6.71001 9.71L12 4.41ZM5.29001 15.71L12 22.41L18.71 15.71L17.29 14.29L12 19.59L6.71001 14.29L5.29001 15.71Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
